import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../features/auth/authSlice';
import { useAppDispatch } from '../../../app/hooks';
import { LogOut } from 'lucide-react';
import '../../../css/Sidebar.css';

const NavBar = () => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleLogout = async () => {
        try {
            await instance.logoutRedirect();
            dispatch(logout());
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <nav style={{ padding: '10px', display: 'flex', justifyContent: 'flex-end' }}>
            {isAuthenticated ? (
                <button onClick={handleLogout} className="sidebar-logout-btn">
                    <LogOut size={16} />
                    <span>Logout</span>
                </button>
            ) : null}
        </nav>
    );
};

export const LogoutButton: React.FC = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect();
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <button onClick={handleLogout} className="sidebar-logout-btn">
      <LogOut size={16} />
      <span>Logout</span>
    </button>
  );
};

export default NavBar;